import { render, staticRenderFns } from "./ProductComboContents.vue?vue&type=template&id=d19ed0ac&scoped=true"
import script from "./ProductComboContents.vue?vue&type=script&lang=js"
export * from "./ProductComboContents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d19ed0ac",
  null
  
)

export default component.exports